module.exports = __webpack_public_path__ + "static/media/sunderland.87733304.webp";